module.exports = __webpack_public_path__ + "static/media/kids_59.09538e12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_59.jpg
// module id = 5915
// module chunks = 0